import React from "react"

export default React.createContext({
  menu: false,
  theme: 'dark'
})
